import { useRef, useState, useEffect } from 'react'
import { ReactSVG } from 'react-svg'

import cn from 'classnames'

import ActiveTabBackground from './images/tab.svg'
import ActiveTabBackgroundBig from './images/tab-big.svg'

import styles from './styles.module.scss'
import { useTranslation } from 'utils/use-translation'

export const TabNames = {
  LOANS: 'Loans',
  SAVINGS: 'Savings',
  WALLETS: 'Wallets',
}

export function OperationCardTabs({ activeTab, onTabChange, tabs }) {
  const { t } = useTranslation()

  const [activePosition, setActivePosition] = useState({ left: -4 })

  const hoverEl = useRef()

  const activateTab = (event, tabName) => {
    onTabChange(tabName)
    const link = event.target.closest('div')
    const linkRect = link.getBoundingClientRect()
    const containerRect = link.parentElement.getBoundingClientRect()
    setActivePosition({ left: linkRect.left - containerRect.left - 4 })
  }

  useEffect(() => {
    const activeLink = document.querySelector(`.${styles.tab}.${styles.activeTab}`)
    if (activeLink) {
      const linkRect = activeLink.getBoundingClientRect()
      const containerRect = activeLink.parentElement.getBoundingClientRect()
      setActivePosition({ left: linkRect.left - containerRect.left - 4 })
    }
  }, [activeTab, tabs])

  return (
    <>
      <div className={styles.tabs}>
        {tabs.map((tab) => (
          <div
            key={tab.name}
            className={cn(styles.tab, { [styles.activeTab]: activeTab === tab.name })}
            style={{ width: tabs.length === 3 ? '33.333%' : '50%' }}
            onClick={(e) => activateTab(e, tab.name)}
          >
            <ReactSVG src={tab.icon} className={styles.icon} />
            <span className={styles.tabText}>{t(tab.name.toLowerCase())}</span>
            <small className={styles.tabCount}>({tab.count})</small>
          </div>
        ))}
        <img
          ref={hoverEl}
          src={tabs.length === 3 ? ActiveTabBackground : ActiveTabBackgroundBig}
          className={styles.activeBackground}
          style={{ transform: `translateX(${activePosition.left}px)`, width: tabs.length === 3 ? '33.333%' : '50%' }}
        />
      </div>
    </>
  )
}
